import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const consentsStyle = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.7);'
    },
    webContainer: {
        width: '50%',
        backgroundColor: 'rgba(0, 0, 0, 0.9)'
    },
    backgroundImage: {
        flex: 1,
        resizeMode: 'cover'
    },

    overlayMobile: {
        position: 'absolute',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        padding: 20,
        margin: 20
    },
    overlayTablet: {
        position: 'absolute',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        width: '60%',
        padding: 20,
        margin: 20,
        alignItems: 'center',
        justifyContent: 'center'
    },
    overlayWeb: {
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        padding: 20,
        margin: 20
    },
    title: {
        fontSize: 30,
        textAlign: 'center',
        color: 'white',
        marginTop: 10,
        fontFamily: Theme.regularFont,
        lineHeight: 34,
        paddingBottom: 20
    },
    spacer: {
        height: 20
    },
    divider: {
        height: 1,
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        width: '100%',
        marginBottom: 20
    },
    contentText: {
        fontSize: 18,
        color: '#FCFCFC',
        textAlign: 'center',
        marginBottom: 10,
        fontFamily: Theme.regularFont,
        lineHeight: 24,
        letterSpacing: 0.065 * 16,
        paddingTop: 20
    },
    contentLink: {
        color: '#FCFCFC',
        fontWeight: '700',
        fontFamily: Theme.boldFont,
        textDecorationLine: 'none'
    },

    buttonContainer: {
        flexDirection: 'column'
    },
    buttonHrizontalAlignment: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        margin: 8
    },
    buttonDetailed: {
        flex: 1,
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.3)',
        paddingVertical: 14,
        borderRadius: 3,
        marginVertical: 15,
        fontFamily: Theme.regularFont,
        fontWeight: '400',
        justifyContent: 'center',
        paddingHorizontal: 20
    },
    grayBackground: {
        backgroundColor: 'rgba(252, 252, 252, 0.15)'
    },
    mobileButtonWidth: { width: '100%' },
    buttonAcceptAll: {
        flex: 1,
        paddingVertical: 16,
        borderRadius: 5,
        paddingLeft: 30,
        fontSize: 18
    },
    buttonText: {
        color: 'white',
        fontSize: 18,
        textAlign: 'center',
        fontWeight: '300'
    },
    modalContainer: {
        flex: 1,
        backgroundColor: 'transparent'
    },
    alignmentsOnWeb: {
        flexDirection: 'row',
        justifyContent: 'center',
        margin: 8,
        width: '80%'
    },
    link: {
        color: 'white',
        textDecorationLine: 'none'
    }
});

export default consentsStyle;
